var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenterLayout',{attrs:{"title":"Impressum","plan":_vm.info.plan,"history":_vm.info.history,"eu-sa":_vm.info.euSa}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.imprint)}})])}
var staticRenderFns = []

export { render, staticRenderFns }